/* eslint react/prop-types: 0 */

import React from "react";
import { withRouter } from "react-router-dom";
import CatalogInputControl from "../../components/CatalogInputControl/CatalogInputControl";

function Footer(props) {
  return (
    <div>
      <div className="playbook-footer-container">
        {props.isVisible ?
          null
          :
          <div className="catalog-footer-search">
            <div className="catalog-footer-text">Enter Catalog Reference #</div>
            <CatalogInputControl />
          </div>
        }
      </div>
    </div>
  );
}





export default withRouter(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js